import React, { useEffect, useState } from 'react';
import './estilos.css';

  const InformesSNDIF = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
       <div className="row">
          <div className="row-content">
               <div className='ldf_titulo'>
                  <h2>Informes a DIF Nacional</h2>
                  <hr className='hr-gob'/>
               </div>

                <div className="acordeon-cuerpo">
                      {/*  <div className="acordeon"> */}
                           {/* <div className="contenedor">*/}
                                <div className="etiqueta" style={{ fontSize: "22px" }}>Informes Físicos Financieros</div>
                                   <div className="contenido-sieb">
                                      <table className="table table-striped table-bordered acordeonTabla" style={{ textAlign: "center" }}>
                                          <tbody>
                                            <tr>
                                                <td colspan="3"><p>SALUD Y BIENESTAR COMUNITARIO 2021</p></td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Periodo Enero - Marzo</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2021/Enero-Marzo21.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Periodo Enero - Junio</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2021/Enero-Junio21.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Periodo Enero - Septiembre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2021/ReporteTrimestralPSBCEnero-Septiembre.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Periodo Enero - Diciembre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2021/ReporteTrimestralPSBCEnero-Diciembre.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colspan="3"><p>SALUD Y BIENESTAR COMUNITARIO 2022</p></td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Trimestre Enero - Marzo</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Enero-Marzo22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Trimestre Abril - Junio</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Abril-Junio22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Periodo Enero - Septiembre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Enero-Septiembre22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>Trimestre Octubre - Diciembre</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2022/Octubre-Diciembre22.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                            
                                            <tr>
                                                <td colspan="3"><p>SALUD Y BIENESTAR COMUNITARIO 2023</p></td>
                                            </tr>
                                            <tr>
                                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                                <td style={{ textAlign: "left" }}>1er. Informe Trimestral PSBC</td>
                                                <td>
                                                  <div>
                                                      <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2023/1er._Informe_Trimestral_del_Recurso_Ejercido_PSBC_2023_Hidalgo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                                <td style={{ textAlign: "left" }}>2do. Informe Trimestral PSBC</td>
                                                <td>
                                                  <div>
                                                      <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2023/2do._Informe_Trimestral_del_Recurso_Ejercido_PSBC_2023_Hidalgo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                                <td style={{ textAlign: "left" }}>3er. Informe Trimestral PSBC</td>
                                                <td>
                                                  <div>
                                                      <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2023/3er._Informe_Trimestral_del_Recurso_Ejercido_PSBC_2023_Hidalgo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                  </div>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                                <td style={{ textAlign: "left" }}>4to. Informe Trimestral PSBC</td>
                                                <td>
                                                  <div>
                                                      <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2023/4to._Informe_Trimestral_del_Recurso_Ejercido_Cierre_2023.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                  </div>
                                                </td>
                                              </tr>
                                            <tr>
                                                <td colspan="3"><p>SALUD Y BIENESTAR COMUNITARIO 2024</p></td>
                                            </tr>
                                            <tr>
                                              <td><div><i className="bi bi-file-earmark-pdf-fill"></i></div></td>
                                              <td style={{ textAlign: "left" }}>1er. Informe Trimestral PSBC</td>
                                              <td>
                                                <div>
                                                    <a href="http://dif.hidalgo.gob.mx/pdf/informes_dif_nacional/2024/1er._Informe_Trimestral_del_Recurso_Ejercido_PSBC_2024_Hidalgo.pdf" target="_blank" rel="noopener noreferrer"><button className="btn btn-default btn-acordeon" type="button">PDF</button></a>
                                                </div>
                                              </td>
                                            </tr>
                                        </tbody>
                                      </table>
                                   </div>
                             {/*  </div>*/}
                        {/*  </div> */}
                     </div>
      


          </div>
       </div>
    </div>


    )
}


  export default InformesSNDIF
